import { Route, Routes, useLocation } from "react-router-dom";
import Home from "../../pages/web/Home";
import NotFound from "../../pages/web/NotFound";
import LoginSignup from "../../pages/web/auth/LoginSignup";
import ContactUs from "../../pages/web/ContactUs";
import TermsAndConditions from "../../components/web/policies/TermsAndConditions";
import PrivacyPolicy from "../../components/web/policies/PrivacyPolicy";
import PageContent from "../../pages/web/PageContent";
import Form from "../../pages/web/Form";
import DownloadApplyPage from "../../pages/web/DownloadApplyPage";
import Dashboard from "../../pages/user/Dashboard";
import Applyform from "../../pages/user/Applyform";
import Idcard from "../../pages/user/Idcard";
import Password from "../../pages/user/Password";
import History from "../../pages/web/page/History";
import Tributes from "../../pages/web/page/Tributes";
import ArtDiretion from "../../pages/web/page/ArtDiretion";
import CostumeDesigner from "../../pages/web/page/CostumeDesigner";
import Rules from "../../pages/web/page/Rules";
import MembershipTerms from "../../pages/web/page/MembershipTerms";
import ApplicationTrack from "../../pages/web/page/ApplicationTrack";
import Profile from "../../pages/user/Profile";
import Notification from "../../pages/web/page/Notification";
import ShowForm from "../../components/web/form/ShowForm";
import useGoogleTranslate from "../../components/web/useGoogleTranslate";
import { useEffect, useRef, useState } from "react";
import { ChevronDown, Globe } from "lucide-react";
import Header from "../../components/web/Header";
import DeleteAccount from "../../pages/user/DeleteAccount";
import Blog from "../../pages/web/page/Blog";
import ServicePage from "../../pages/web/page/ServicePage";
import ForgotPassword from "../../pages/web/auth/ForgotPassword";
import PaymentWallet from "../../pages/user/PaymentWallet";
import PaymentCallback from "../../pages/user/PaymentCallback";

const AppRoutes = () => {

  const location = useLocation();
  const authPath = location.pathname.split("/")[1];




  return (
    <>


      <div className={1==1 ? 'animate-fadeIn' : location.pathname === '/' ? 'opacity-0' : 'animate-fadeIn'}>
        {authPath !== "auth" && <Header />}


        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="*" element={<NotFound />} />
          <Route path="/auth/login" element={<LoginSignup />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/our-history" element={<History />} />
          <Route path="/our-tributes" element={<Tributes />} />
          <Route path="/living-legends-of-art-direction" element={<ArtDiretion />} />
          <Route path="/living-legends-of-costume-designer" element={<CostumeDesigner />} />
          <Route path="/blogs" element={<Rules />} />
          <Route path="/blogs/:slug" element={<Blog />} />
          <Route path="/membership-terms" element={<MembershipTerms />} />
          <Route path="/track-your-application" element={<ApplicationTrack />} />

          <Route path="/auth/forgot-password" element={<ForgotPassword />} />

          <Route path="/page/:label" element={<PageContent />} />
          <Route path="/account-delete" element={<DeleteAccount />} />
          <Route path="/apply-form/:type" element={<Form />} />
          <Route path="/show-form/:type" element={<ShowForm />} />
          <Route path="/download-apply-form" element={<DownloadApplyPage />} />
          <Route path="/member/dashboard" element={<Dashboard />} />
          <Route path="/member" element={<Dashboard />} />
          <Route path="/notifications" element={<Notification />} />
          <Route path="/member/profile" element={<Profile />} />
          <Route path="/member/download-apply-form" element={<Applyform />} />
          <Route path="/member/id-card" element={<Idcard />} />

          <Route path="/member/change-password" element={<Password />} />

          <Route path="/member/ambulance" element={<ServicePage service="Ambulance" />} />
          <Route path="/member/blood-test" element={<ServicePage service="Blood Test" />} />
          <Route path="/member/insurance" element={<ServicePage service="Insurance" />} />
          <Route path="/member/bank-account" element={<ServicePage service="Bank Account" />} />
          <Route path="/member/pension" element={<ServicePage service="Pension" />} />
          <Route path="/member/payment" element={<ServicePage service="Payment" />} />
          <Route path="/member/govt-rules" element={<ServicePage service="Govt Rules" />} />
          <Route path="/member/rights" element={<ServicePage service="Rights" />} />
          <Route path="/member/shopping" element={<ServicePage service="Shopping" />} />
          <Route path="/member/medicine" element={<ServicePage service="Medicine" />} />
          <Route path="/member/loan" element={<ServicePage service="Loan" />} />
          <Route path="/member/itr" element={<ServicePage service="ITR" />} />
          <Route path="/member/payments" element={<PaymentWallet />} />
          <Route path="/member/payment/callback/phonepe" element={<PaymentCallback />} />
          <Route path="/payment/callback/phonepe" element={<PaymentCallback />} />
        </Routes>
      </div>
      <style>{`
        .animate-fadeIn {
          animation: fadeIn 1s ease-out;
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

    </>
  );
};
export default AppRoutes;
